export default "__VITE_ASSET__018cd79e__"